import script from "./TextAlternativeQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAlternativeQuestion.vue?vue&type=script&setup=true&lang=js"

import "./TextAlternativeQuestion.vue?vue&type=style&index=0&id=7a7981a1&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7981a1"]])

export default __exports__